import styled from 'styled-components';
import { Conveyance } from './conveyance';
import { Destination } from './destination';
import { FindAlocation } from './find-a-location';
import { Stack } from '@/components/ui';
import { useSelector } from '@/redux';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { selectConveyance } from '@/redux/conveyanceMode/reducer';

export function MenuAvailability() {
  const { location } = useSelector(selectConveyance);

  return (
    <Container>
      <MenuWrapper>
        {!location ? (
          <Stack align="center" position="center">
            <FindAlocation />
          </Stack>
        ) : (
          <>
            <ConveyanceWrapper>
              <Conveyance />
            </ConveyanceWrapper>
            <DestinationWrapper>
              <Destination />
            </DestinationWrapper>
          </>
        )}
      </MenuWrapper>
    </Container>
  );
}

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 4px;
  }
`;

const ConveyanceWrapper = styled.div`
  display: flex;
  align-items: center;
  width: auto;
`;

const DestinationWrapper = styled.div`
  display: flex;
  align-items: center;

  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: -1px;
    padding-top: 0;
  }
`;

const Container = styled.div(({ theme }) => ({
  ...getFontStyles(theme.header.font, {
    font_size: (value) => {
      if (typeof value !== 'number') {
        return value;
      }

      if (value * 0.75 < 14) {
        return 14;
      }

      return value * 0.75;
    },
  }),
  maxWidth: '100%',

  '@media (min-width: 768px)': {
    ...getFontStyles(theme.header.font, ['font_size']),
  },
}));
